module.exports = __webpack_public_path__ + "static/media/blackclosemenu.0e4ab089.svg";